import { LiveAiPolicyProvider } from "@/pages/GovernancePage/components/organisms/LiveAiPolicyProvider"
import { TabsDrawerTemplate } from "../TabsDrawerTemplate"
import { TitleAiPolicyViolationsDrawer } from "./components/TitleAiPolicyViolationsDrawer"
import { ViolationLog } from "./components/ViolationLog"

import type { AiPolicyViolationsDrawerProps } from "./AiPolicyViolationsDrawer.types"

const WIDTH = 1000

// The violation log of one real AI policy: its rules, then its violations from
// its decisions. The live policies give the rules their labels, as on the
// policy's page
export const AiPolicyViolationsDrawer = (
  props: AiPolicyViolationsDrawerProps
) => {
  const { widthAdditive, ...restProps } = props

  return (
    <LiveAiPolicyProvider>
      <TabsDrawerTemplate
        name="AiPolicyViolationsDrawer"
        tabs={[]}
        components={[]}
        Title={TitleAiPolicyViolationsDrawer}
        width={WIDTH + widthAdditive}
        {...restProps}
      >
        <ViolationLog drawerId={props.id} />
      </TabsDrawerTemplate>
    </LiveAiPolicyProvider>
  )
}
